import { type PermisosEfectivos } from '@mg/shared';
import { Outlet } from 'react-router';
import { VentanaRegistrado } from '@/componentes/Registrado.tsx';
import { useAuth } from '@/lib/auth.tsx';
import { Header } from './Header.tsx';
import { Sidebar } from './Sidebar.tsx';

export function AppLayout() {
  const { usuario } = useAuth();
  if (!usuario) return null;
  return (
    <div className="flex h-full min-h-screen">
      <Sidebar rol={usuario.rol} permisos={usuario.permisos as PermisosEfectivos} sucursal={usuario.sucursal_nombre} />
      <div className="flex min-w-0 flex-1 flex-col">
        <Header />
        <main className="flex-1 overflow-y-auto p-5">
          <Outlet />
        </main>
      </div>
      <VentanaRegistrado />
    </div>
  );
}

/** Encabezado de página estándar. */
export function TituloPagina({ titulo, subtitulo, acciones }: { titulo: string; subtitulo?: string; acciones?: React.ReactNode }) {
  return (
    <div className="mb-4 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h1 className="text-xl font-semibold tracking-tight">{titulo}</h1>
        {subtitulo ? <p className="text-sm text-muted-foreground">{subtitulo}</p> : null}
      </div>
      {acciones ? <div className="flex items-center gap-2">{acciones}</div> : null}
    </div>
  );
}
